import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "financialFitnessBars" };
const _hoisted_2 = { class: "startedBackground" };
const _hoisted_3 = { class: "dayToDayBackground" };
const _hoisted_4 = { class: "securityBackground" };
const _hoisted_5 = { class: "futureBackground" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancialFitnessBars',
    props: {
        started: {},
        dayToDay: {},
        security: {},
        future: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('click', 'Getting started'))),
                        class: "barProgress started",
                        style: _normalizeStyle('width: ' + _ctx.started + '%;')
                    }, " Getting Started (" + _toDisplayString(_ctx.started) + "%) ", 5)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('click', 'Day-to-day finances'))),
                        class: "barProgress dayToDay",
                        style: _normalizeStyle('width: ' + _ctx.dayToDay + '%;')
                    }, " Day to Day (" + _toDisplayString(_ctx.dayToDay) + "%) ", 5)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = ($event) => (emit('click', 'Security and protection'))),
                        class: "barProgress security",
                        style: _normalizeStyle('width: ' + _ctx.security + '%;')
                    }, " Security and Protection (" + _toDisplayString(_ctx.security) + "%) ", 5)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('click', 'Invest in my future'))),
                        class: "barProgress future",
                        style: _normalizeStyle('width: ' + _ctx.future + '%;')
                    }, " Invest in my Future (" + _toDisplayString(_ctx.future) + "%) ", 5)
                ])
            ]));
        };
    }
});
